import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { GetKaroakeListRequest } from '../api/karoake/getkaroakelist/getkaroakelistrequest';
import { GetKaroakeListResponse, GetKaroakeListResponseDtoImpl } from '../api/karoake/getkaroakelist/getkaroakelistresponse';
import { GetKaroakeListBuilder } from '../dto/getkaroakelist/getkaroakelistbuilder';
import { GetKaroakeListDtoImpl } from '../dto/getkaroakelist/getkaroakelistdto';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';
import { Strings } from '../../utils/resources/strings';

export class GetKaroakeListAPIProcessorImpl extends SixdeeCRBTAPIProcessor<GetKaroakeListRequest, GetKaroakeListResponse>
{
    execute(request: GetKaroakeListRequest): void 
    {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new GetKaroakeListResponseDtoImpl(APIFeatures.GET_KAROAKE_LIST, "Get Karoake List Success"); //GetKaroakeListDtoImpl

                let getKaroakeListDto = new GetKaroakeListDtoImpl();
                getKaroakeListDto.setListOfTones(new GetKaroakeListBuilder(responseMapper.getResponseMap()).buildAll());

                response.setKaroakeListDto(getKaroakeListDto);

                this.getAPISuccess(response);
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new GetKaroakeListResponseDtoImpl(APIFeatures.GET_KAROAKE_LIST, "Get Karoake List Data not Available"));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new GetKaroakeListResponseDtoImpl(APIFeatures.GET_KAROAKE_LIST, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch (e) {
            this.getAPIFailure(new GetKaroakeListResponseDtoImpl(APIFeatures.GET_KAROAKE_LIST, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        super.onFailure(responseMapper);
   
            this.getAPIFailure(new GetKaroakeListResponseDtoImpl(APIFeatures.GET_KAROAKE_LIST, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/getkaroakelistapiprocessor.tsx